import React, { useEffect, useRef } from 'react';
import './GroupPlanModal.css';

interface GroupPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GroupPlanModal: React.FC<GroupPlanModalProps> = ({
  isOpen,
  onClose
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      // Focus the close button when modal opens
      closeButtonRef.current?.focus();
      
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      // Restore body scroll when modal closes
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="group-plan-modal-backdrop" 
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="group-modal-title"
      aria-describedby="group-modal-description"
    >
      <div className="group-plan-modal" ref={modalRef}>
        <div className="group-plan-modal-header">
          <div className="group-plan-modal-header-top">
            <h2 id="group-modal-title" className="group-plan-modal-title">
              Group
            </h2>
            <button
              ref={closeButtonRef}
              className="group-plan-modal-close"
              onClick={onClose}
              aria-label="Close modal"
            >
              ×
            </button>
          </div>
          <p id="group-modal-description" className="group-plan-modal-subtitle">
            Here are the important reminder/s before you purchase.
          </p>
        </div>
        
        <div className="group-plan-modal-content">         
          <ul className="group-plan-modal-list">
            <li>
              The Group Plan is available if you plan to travel on the same departure and return trip with your Group, and you and your group members must be 18 to 75 years old, and your children's age must range from 0 to 17 years old.
            </li>
            <li>
              This system can only accommodate a group of up to fifteen (15) members. If you wish to insure more than 15 group members, who are 18 years old and above. For further assistance, please email{' '}
              <a 
                href="mailto:traveldirect_team@pacificcross.com.ph" 
                className="group-plan-modal-email-link"
              >
                traveldirect_team@pacificcross.com.ph
              </a>.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GroupPlanModal;